import { Type } from '../../../../general/modules/filter/dataModel';
import { IntroCellInner } from '../components/cells/IntroCell';
import { WithLoader } from '../components/cells/WithLoader';
import { FilterEnumContainer } from '../components/plugins/filters/FilterEnumContainer';
import { Column, FMColumn } from '../model';

export const introCol: FMColumn<Type.ID> = {
  key: Column.intro,
  dataKey: Column.intro,
  title: 'Intro',
  width: 110,
  sortable: true,
  cellRenderer: WithLoader(IntroCellInner),
  className: 'ch-file-manager__cell_intro',
  plugins: [FilterEnumContainer],
  filter: Type.ID,
  getter: (row) => row.creative?.intro?.id ?? null,
  toDisplayString: (row) => {
    return row.creative?.intro?.name ?? null;
  },
};
